module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "footer3",
    staticClass: "footer3"
  }, [_c('img', {
    attrs: {
      "src": _vm.bottomGzh,
      "alt": "",
      "width": "247px"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.bottomDesc)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d05ca9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer.vue
// module id = 362
// module chunks = 3 4 5 9 13 14 15 16 23 24 25 26